// ======================================================================
// File Name       : AuthorityAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import { AUTHORITY_RECEIVE_LIST } from '../constants/ActionTypes';
import { commonCallApi } from '../utils/ApiUtils';
import { SELECT_TARGET_DATA } from '../constants/index';

function receiveAuthorityList(recordNum, managementAuthorityList) {
  return {
    type: AUTHORITY_RECEIVE_LIST,
    recordNum,
    managementAuthorityList,
  };
}

export function getAuthorityList(param) {
  if (!param) {
    param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
  }
  return dispatch =>
    commonCallApi({
      path: 'userAuthority/GetList',
      data: param,
      institutionId: 1,
    }).then((resdata) => {
      if (param.selectTargetData === SELECT_TARGET_DATA.CSV) {
        if (resdata && resdata.csvfileUrl) {
          const link = document.createElement('a');
          link.href = resdata.csvfileUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } else {
        const { recordNum, managementAuthorityList } = resdata;
        dispatch(receiveAuthorityList(recordNum, managementAuthorityList));
      }
    });
}

export function authorityEdit(param) {
  return (dispatch) => {
    return commonCallApi({
      path: 'userAuthority/Edit',
      data: param,
      institutionId: 1,
    });
  };
}
